import { appstr } from "@coreapp/utils/appstr";
import FieldSelector from "../FieldSelector";
import { IsPositionChart } from "@coreapp/utils/IsPositionChart";

export const ImportFilterFieldInput = props => {
  const handleClick = (_, fieldValue) => {
    props.onFieldChange?.(fieldValue.fieldName);

    props.setImportFilter(prev => ({
      ...prev,
      field: fieldValue.fieldName,
      fieldType: fieldValue.fieldType
    }));
  };

  return (
    <FieldSelector
      chartConfig={props.chartConfig}
      onClick={handleClick}
      fieldName={props.importFilter.field}
      fieldType={props.importFilter.fieldType}
      dataTestIdPrefix={props.dataTestIdPrefix}
      containerProps={{
        label: appstr("Field"),
        listProps: {
          enableSearch: !IsPositionChart(props.chartConfig)
        }
      }}
    />
  );
};
